import { removeNamespace } from '@/utils/helpers'
import { PromotionType, PromotionTypeTab, PromotionStateTab, PromotionSortBy } from '../../utils/enums/promotion-enums'
import PromotionService from '@/services/promotion.service'
import * as cloneDeep from 'lodash.clonedeep'

export const PROMOTIONS_TYPES = {
  getters: {
    typeTabs: 'promotions/typeTabs',
    stateTabs: 'promotions/stateTabs',
    currentTab: 'promotions/currentTab'
  },
  mutations: {
    SET_LOADING: 'promotions/SET_LOADING',
    SET_TYPE_TAB: 'promotions/SET_TYPE_TAB',
    SET_STATE_TAB: 'promotions/SET_STATE_TAB',
    SET_PAGED_PROMOTIONS: 'promotions/SET_PAGED_PROMOTIONS',
    SET_TAB_PROMO_TOTAL: 'promotions/SET_TAB_PROMO_TOTAL',
    SET_TABLE_OPTIONS: 'promotions/SET_TABLE_OPTIONS',
    SET_SEARCH_OPTIONS: 'promotions/SET_SEARCH_OPTIONS'
  },
  actions: {
    changeTab: 'promotions/changeTab',
    changeTypeTab: 'promotions/changeTypeTab',
    changeStateTab: 'promotions/changeStateTab',
    changeSearch: 'promotions/changeSearch',
    changeSort: 'promotions/changeSort',
    changeTableOptions: 'promotions/changeTableOptions',
    fetchPromotionsPaged: 'promotions/fetchPromotionsPaged',
    fetchPromotionsForExport: 'promotions/fetchPromotionsForExport'
  }
}

const _types = removeNamespace('promotions', PROMOTIONS_TYPES)

const defaultTableOptions = {
  page: 1,
  itemsPerPage: 10
}

const defaultSearchOptions = {
  keyword: '',
  orderBy: PromotionSortBy.CreatedAt,
  orderDescending: true
}

const tabs = [
  {
    type: PromotionTypeTab.AutomaticDiscounts,
    state: PromotionStateTab.All,
    params: {
      promotionType: PromotionType.Automatic,
      promotionState: PromotionStateTab.All
    }
  },
  {
    type: PromotionTypeTab.AutomaticDiscounts,
    state: PromotionStateTab.Active,
    params: {
      promotionType: PromotionType.Automatic,
      promotionState: PromotionStateTab.Active
    }
  },
  {
    type: PromotionTypeTab.AutomaticDiscounts,
    state: PromotionStateTab.Scheduled,
    params: {
      promotionType: PromotionType.Automatic,
      promotionState: PromotionStateTab.Scheduled
    }
  },
  {
    type: PromotionTypeTab.AutomaticDiscounts,
    state: PromotionStateTab.Expired,
    params: {
      promotionType: PromotionType.Automatic,
      promotionState: PromotionStateTab.Expired
    }
  },
  {
    type: PromotionTypeTab.DiscountCodes,
    state: PromotionStateTab.All,
    params: {
      promotionType: PromotionType.DiscountCode,
      promotionState: PromotionStateTab.All
    }
  },
  {
    type: PromotionTypeTab.DiscountCodes,
    state: PromotionStateTab.Active,
    params: {
      promotionType: PromotionType.DiscountCode,
      promotionState: PromotionStateTab.Active
    }
  },
  {
    type: PromotionTypeTab.DiscountCodes,
    state: PromotionStateTab.Scheduled,
    params: {
      promotionType: PromotionType.DiscountCode,
      promotionState: PromotionStateTab.Scheduled
    }
  },
  {
    type: PromotionTypeTab.DiscountCodes,
    state: PromotionStateTab.Expired,
    params: {
      promotionType: PromotionType.DiscountCode,
      promotionState: PromotionStateTab.Expired
    }
  },
  {
    type: PromotionTypeTab.PriceAdjustments,
    state: PromotionStateTab.All,
    params: {
      promotionType: PromotionType.PriceAdjustment,
      promotionState: PromotionStateTab.All
    }
  },
  {
    type: PromotionTypeTab.PriceAdjustments,
    state: PromotionStateTab.Active,
    params: {
      promotionType: PromotionType.PriceAdjustment,
      promotionState: PromotionStateTab.Active
    }
  },
  {
    type: PromotionTypeTab.PriceAdjustments,
    state: PromotionStateTab.Scheduled,
    params: {
      promotionType: PromotionType.PriceAdjustment,
      promotionState: PromotionStateTab.Scheduled
    }
  },
  {
    type: PromotionTypeTab.PriceAdjustments,
    state: PromotionStateTab.Expired,
    params: {
      promotionType: PromotionType.PriceAdjustment,
      promotionState: PromotionStateTab.Expired
    }
  },
  {
    type: PromotionTypeTab.Bundle,
    state: PromotionStateTab.All,
    params: {
      promotionType: PromotionType.Bundle,
      promotionState: PromotionStateTab.All
    }
  },
  {
    type: PromotionTypeTab.Bundle,
    state: PromotionStateTab.Active,
    params: {
      promotionType: PromotionType.Bundle,
      promotionState: PromotionStateTab.Active
    }
  },
  {
    type: PromotionTypeTab.Bundle,
    state: PromotionStateTab.Scheduled,
    params: {
      promotionType: PromotionType.Bundle,
      promotionState: PromotionStateTab.Scheduled
    }
  },
  {
    type: PromotionTypeTab.Bundle,
    state: PromotionStateTab.Expired,
    params: {
      promotionType: PromotionType.Bundle,
      promotionState: PromotionStateTab.Expired
    }
  }
]

const state = () => ({
  loading: false,
  tabs: tabs,
  typeTab: PromotionTypeTab.AutomaticDiscounts,
  stateTab: PromotionStateTab.All,
  tableOptions: cloneDeep(defaultTableOptions),
  searchOptions: cloneDeep(defaultSearchOptions),
  pagedPromotions: [],
  tabPromoTotal: 0
})

const getters = {
  [_types.getters.typeTabs]: state => {
    const tabs = state.tabs.map(x => x.type)
    return [...new Set(tabs)]
  },
  [_types.getters.stateTabs]: state => {
    return state.tabs.filter(x => x.type === state.typeTab)
      .map(x => x.state)
  },
  [_types.getters.currentTab]: state => {
    return state.tabs.find(x => x.type === state.typeTab && x.state === state.stateTab)
  }
}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_TYPE_TAB] (state, typeTab) {
    state.typeTab = typeTab
  },
  [_types.mutations.SET_STATE_TAB] (state, stateTab) {
    state.stateTab = stateTab
  },
  [_types.mutations.SET_TABLE_OPTIONS] (state, options) {
    state.tableOptions = cloneDeep(options)
  },
  [_types.mutations.SET_SEARCH_OPTIONS] (state, options) {
    state.searchOptions = cloneDeep(options)
  },
  [_types.mutations.SET_PAGED_PROMOTIONS] (state, pagedResult) {
    state.pagedPromotions = pagedResult
  },
  [_types.mutations.SET_TAB_PROMO_TOTAL] (state, count) {
    state.tabPromoTotal = count
  }
}

const actions = {
  [_types.actions.changeTab] ({ state, commit, dispatch }, { typeTab, stateTab }) {
    commit(_types.mutations.SET_LOADING, true)
    commit(_types.mutations.SET_TYPE_TAB, typeTab)
    commit(_types.mutations.SET_STATE_TAB, stateTab)
    commit(_types.mutations.SET_PAGED_PROMOTIONS, [])
    commit(_types.mutations.SET_TAB_PROMO_TOTAL, 0)
    commit(_types.mutations.SET_TABLE_OPTIONS, defaultTableOptions)
    commit(_types.mutations.SET_SEARCH_OPTIONS, defaultSearchOptions)
    dispatch(_types.actions.fetchPromotionsPaged)
  },
  [_types.actions.changeTypeTab] ({ state, dispatch }, typeTab) {
    dispatch(_types.actions.changeTab, {
      typeTab,
      stateTab: state.stateTab
    })
  },
  [_types.actions.changeStateTab] ({ state, dispatch }, stateTab) {
    dispatch(_types.actions.changeTab, {
      typeTab: state.typeTab,
      stateTab
    })
  },
  [_types.actions.fetchPromotionsPaged] ({ state, commit, getters }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page } = state.tableOptions
    const { keyword, orderBy, orderDescending } = state.searchOptions
    const params = {
      ...getters.currentTab.params,
      keyword,
      skipCount: (page - 1) * itemsPerPage,
      maxResultCount: itemsPerPage,
      orderBy,
      orderDescending
    }
    return PromotionService.getAllPaged(params)
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_PROMOTIONS, items)
        commit(_types.mutations.SET_TAB_PROMO_TOTAL, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchPromotionsForExport] ({ state, commit, getters }) {
    commit(_types.mutations.SET_LOADING, true)
    const { keyword, orderBy, orderDescending } = state.searchOptions
    const params = {
      ...getters.currentTab.params,
      keyword,
      orderBy,
      orderDescending
    }
    return PromotionService.getAll(params)
      .then((res) => {
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.changeSearch] ({ state, commit, dispatch }, searchTerm) {
    const keyword = searchTerm ? searchTerm.replace(/(<([^>]+)>)/ig, '') : ''
    commit(_types.mutations.SET_SEARCH_OPTIONS, {
      ...state.searchOptions,
      keyword
    })
    dispatch(_types.actions.fetchPromotionsPaged)
  },
  [_types.actions.changeSort] ({ state, commit, dispatch }, { orderBy, orderDescending }) {
    commit(_types.mutations.SET_SEARCH_OPTIONS, {
      ...state.searchOptions,
      orderBy,
      orderDescending
    })
    dispatch(_types.actions.fetchPromotionsPaged)
  },
  [_types.actions.changeTableOptions] ({ state, commit, dispatch }, { page, itemsPerPage }) {
    if (page !== state.tableOptions.page || itemsPerPage !== state.tableOptions.itemsPerPage) {
      commit(_types.mutations.SET_TABLE_OPTIONS, {
        ...state.tableOptions,
        page,
        itemsPerPage
      })
      dispatch(_types.actions.fetchPromotionsPaged)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
